import { createBrowserRouter, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";

import Loading from "./componets/loading/Loading.jsx";

// Lazy loading pages
const Root = lazy(() => import("./pages/Root.jsx"));
const Home = lazy(() => import("./pages/Home.jsx"));
const Detail = lazy(() => import("./pages/Detail.jsx"));
const Cart = lazy(() => import("./pages/Cart.jsx"));
const Checkout = lazy(() => import("./pages/Checkout.jsx"));
const ProfileRoot = lazy(() => import("./pages/ProfileRoot.jsx"));
const Profile = lazy(() => import("./pages/Profile.jsx"));
const Orders = lazy(() => import("./pages/Orders.jsx"));
const OrderReview = lazy(() => import("./pages/OrderView.jsx"));
const Products = lazy(() => import("./pages/Products.jsx"));
const ProductSearch = lazy(() => import("./pages/ProductSearch.jsx"));
const Contact = lazy(() => import("./pages/Contact.jsx"));
const Catalogs = lazy(() => import("./pages/Catalogs.jsx"));

const AdminBase = lazy(() => import("./pages/admin/AdminBase.jsx"));
const Admin = lazy(() => import("./pages/admin/Admin.jsx"));
const ProductAdmin = lazy(() => import("./pages/admin/Product.jsx"));
const ProductsAdd = lazy(() => import("./pages/admin/ProductAdd.jsx"));
const ProductEdit = lazy(() => import("./pages/admin/ProductEdit.jsx"));
const ProductOptions = lazy(() => import("./pages/admin/ProductOptions.jsx"));
const AdminOrders = lazy(() => import("./pages/admin/Orders.jsx"));

const Login = lazy(() => import("./pages/account/login.jsx"));
const Logout = lazy(() => import("./pages/account/Logout.jsx"));

const NotFound = lazy(() => import("./pages/NotFound.jsx"));
const TermsAndConditions = lazy(() => import("./pages/TermsAndConditions.jsx"));


// Suspense wrapper (toza kod uchun)
const Load = (element) => <Suspense fallback={<Loading />}>{element}</Suspense>;

const router = createBrowserRouter([
    {
        path: "/",
        element: <Navigate to="/uz/" replace={false} />,
    },
    {
        path: "admin/",
        element: Load(<AdminBase />),
        errorElement: Load(<NotFound />),
        children: [
            { index: true, element: Load(<Admin />) },
            { path: "orders/", element: Load(<AdminOrders />) },
            { path: "products/", element: Load(<ProductAdmin />) },
            { path: "products/:productId/", element: Load(<ProductEdit />) },
            { path: "products/:productId/options/", element: Load(<ProductOptions />) },
            { path: "product/add/", element: Load(<ProductsAdd />) },
        ],
    },
    {
        path: "login/",
        element: Load(<Login />),
    },
    {
        path: "agreement/",
        element: Load(<TermsAndConditions />),
    },
    {
        path: ":lang/",
        element: Load(<Root />),
        errorElement: Load(<NotFound />),
        children: [
            { index: true, element: Load(<Home />) },
            { path: "products/", element: Load(<Products />) },
            { path: "products/s", element: Load(<ProductSearch />) },
            { path: "product/:product_id/", element: Load(<Detail />) },
            { path: "product/category/:categoryId", element: Load(<Catalogs />) },
            { path: "cart/", element: Load(<Cart />) },
            { path: "checkout/", element: Load(<Checkout />) },
            { path: "contact/", element: Load(<Contact />) },
            { path: "loading/", element: <Loading /> },

            {
                path: "profile/",
                element: Load(<ProfileRoot />),
                children: [
                    { index: true, element: Load(<Profile />) },
                    { path: "orders/", element: Load(<Orders />) },
                    { path: "orders/:order_pk/", element: Load(<OrderReview />) },
                ],
            },
            { path: "logout/", element: Load(<Logout />) },
        ],
    },
    {
        path: "*",
        element: Load(<NotFound />),
    },
]);

export default router;
